import React from "react";
import { SkeletonComponents } from ".";

export const LayoutSkeleton = (): React.ReactElement => {
  return (
    <div
      className="min-h-screen overflow-hidden bg-background"
      role="status"
      aria-busy="true"
      aria-label="Loading application"
    >
      <SkeletonComponents.headerSkeleton />
      <div className="flex relative bg-background min-h-screen">
        <SkeletonComponents.sidebarSkeleton />
      </div>
    </div>
  );
};
